// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ace-container[data-v-4de4d4c8]{height:100%}.ace-editor--height[data-v-4de4d4c8]{height:100%!important}", ""]);
// Exports
module.exports = exports;
